/* Volume info tooltip — Laura Tempesta PDP cup buttons.
   Toggle on "?" click. Close on Esc, outside click, backdrop tap, or "×". */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var triggers = document.querySelectorAll('.mpl-vol-tip-trigger');
    if (!triggers.length) return;

    var tips = document.querySelectorAll('.mpl-vol-tip');
    tips.forEach(function (tip) { tip.removeAttribute('hidden'); });

    var openTip = null;
    var openTrigger = null;

    function closeOpen(returnFocus) {
      if (!openTip) return;
      openTip.classList.remove('is-open');
      var prev = openTrigger;
      openTip = null;
      openTrigger = null;
      if (prev) {
        prev.setAttribute('aria-expanded', 'false');
        if (returnFocus !== false) {
          try { prev.focus({ preventScroll: true }); } catch (e) { prev.focus(); }
        }
      }
    }

    function openFor(trigger) {
      var id = trigger.getAttribute('aria-controls');
      var tip = id ? document.getElementById(id) : null;
      if (!tip) return;
      if (openTip === tip) { closeOpen(); return; }
      if (openTip) closeOpen(false);
      tip.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      openTip = tip;
      openTrigger = trigger;
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (trigger.hasAttribute('disabled')) return;
        openFor(trigger);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!openTip) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.stopPropagation();
        closeOpen();
      }
    });

    document.addEventListener('click', function (e) {
      if (!openTip) return;
      var t = e.target;
      if (!t) return;
      if (t.closest && t.closest('.mpl-vol-tip__close')) {
        e.preventDefault();
        closeOpen();
        return;
      }
      if (t.classList && t.classList.contains('mpl-vol-tip__backdrop')) {
        closeOpen();
        return;
      }
      if (openTip.contains(t)) return;
      if (t.closest && t.closest('.mpl-vol-tip-trigger')) return;
      closeOpen();
    });
  });
})();
